import ButtonWithIcon from "@/components/common/button-with-icon";
import deleteIcon from "@/assets/convert/delete.svg";
import deleteDisabledIcon from "@/assets/convert/delete-disabled.svg";
import { CommandButtonProps } from "@/components/common/command-buttons/data/command-button.data";

const DeleteButton = ({
  isEnabled,
  handleClick,
  hideText,
}: CommandButtonProps) => {
  return (
    <ButtonWithIcon
      isEnabled={isEnabled}
      handleClick={handleClick}
      text={hideText ? undefined : "Delete"}
      iconPath={deleteIcon}
      disabledIconPath={deleteDisabledIcon}
      tooltip="Delete"
    />
  );
};

export default DeleteButton;
